import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import annapolisHawksLogo from "../../assets/logos/annapolisHawks_logo.png";
import threeDLacrosseUpstateLogo from "../../assets/logos/3dLacrosseUpstate_logo.png";
import advncLogo from "../../assets/logos/advnc_logo.jpg";
import arcLacrosseLogo from "../../assets/logos/arcLacrosse_logo.png";
import fogCityLogo from "../../assets/logos/fogCity_logo.png";
import mountainWestLogo from "../../assets/logos/mountainWest_logo.png";
import nationalsLCLogo from "../../assets/logos/nationalsLC_logo.png";
import TestimonialModal from "./TestimonialModal";

const teamLogos = [
  annapolisHawksLogo,
  threeDLacrosseUpstateLogo,
  advncLogo,
  arcLacrosseLogo,
  fogCityLogo,
  mountainWestLogo,
  nationalsLCLogo,
];

const settings = {
  dots: false,
  infinite: true,
  draggable: false,
  slidesToScroll: 1,
  slidesToShow: 3,
  autoplay: true,
  speed: 3000,
  autoplaySpeed: 3000,
  pauseOnHover: false,
  swipe: false,
  touchMove: false,
  cssEase: "linear",
  variableWidth: true, // allow each slide to size to content
  centerMode: false, // avoid centering behavior
};

export default function TeamLogoCloud() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div id="reviews" className="bg-ttNavy-500 py-4 sm:py-8">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="relative overflow-hidden">
          <div className="mb-4 text-center text-white text-lg font-bold">
            The top teams in the country use us
          </div>

          <div className="slider-container">
            <Slider {...settings}>
              {teamLogos.map((teamLogo, index) => (
                <div
                  key={index}
                  className="px-4 py-0"
                  style={{ width: "auto" }}
                >
                  <img
                    src={teamLogo}
                    alt={`Logo ${index}`}
                    className="h-16 w-auto object-contain"
                    style={{ margin: "0 auto" }} // center image if needed
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
        <div className="mt-8 flex justify-center">
          <p className="relative rounded-full border-2 border-ttOrange-400 px-4 py-1.5 text-sm leading-6 text-white hover:bg-ttOrange-400 hover:bg-opacity-25 transition">
            <button
              className="font-semibold text-white"
              onClick={() => setIsModalOpen(true)}
            >
              <span className="absolute inset-0" aria-hidden="true" /> Read our
              customer stories <span aria-hidden="true">&rarr;</span>
            </button>
          </p>
        </div>
        <TestimonialModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      </div>
    </div>
  );
}
